<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>客户管理</el-breadcrumb-item>
    <el-breadcrumb-item>体验机续费管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card" v-if="!iframestatus">
      <!-- 查询 -->
      <el-form :inline="true" :model="keywords" class="demo-form-inline">
        <el-form-item label="">
          <el-input v-model="keywords.loginname" @keyup.enter.native="clicksearch" placeholder="请输入登录名称" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="keywords.cardnumber" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="">
          <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="keywords.bomsn" placeholder="请选择" class="select" style="width: 200px;">
            <el-option
              v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksearch">查询</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表 -->
      <el-table v-loading="loading" :data="dataList" border stripe>
        <el-table-column prop="Loginname" label="登录名称"></el-table-column>
        <el-table-column prop="Name" label="姓名"></el-table-column>
        <el-table-column prop="Phone" label="电话号码"></el-table-column>
        <el-table-column prop="Jigouname" label="归属机构"></el-table-column>
        <el-table-column prop="Cardnumber" label="保修卡号"></el-table-column>
        <el-table-column prop="BomsnName" label="设备类型"></el-table-column>
        <el-table-column prop="SaletypeName" label="销售类型"></el-table-column>
        <el-table-column prop="Yue" label="剩余分钟" width="300px"></el-table-column>
        <el-table-column prop="operation" label="操作">
          <template v-slot="scope">
            <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="renew(scope.row)">续费</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pages">
        <el-pagination
          @current-change="handleCurrentPageChange"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="dataListnum"
		  :current-page.sync="selectedPageNo">
        </el-pagination>
      </div>
    </el-card>

    <el-card class="box-card" v-if="iframestatus">
      <div>
        <el-button type="primary" @click="clickreturn">返回</el-button>
      </div>
      <div id="iframe-container" style="width: 100%;height: 750px;">
        <iframe :src="iframesrc" scrolling="auto" frameborder="0" id="iframe" style="width: 100%;height: 100%;"></iframe>
      </div>
    </el-card>

  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyRenewalTyjManagement',
  data () {
    return {
      loading: false,
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      bomSnList: [],
      keywords: {
        loginname: '',
        name: '',
        phone: '',
        cardnumber: '',
        jigouid: '-1',
        jigouname: '',
        bomsn: '103-0000-0003',
        saletype: '2'
      },
      SubRule_ExcelRenewal: false,
      iframesrc: '',
      iframestatus: false
    }
  },
  mounted () {
    this.apiGetrenewaltyjnum()
    this.apiGetrenewaltyjlist()

    var that = this
    Vue.prototype.FunListBomsn(function (response) {
      if (response.data.Code === 200) {
        that.bomSnList = []
        response.data.List.forEach((item) => {
          if (item.Value != '103-0000-0004') {
            that.bomSnList.push({ Label: item.Label, Value: item.Value })
          }
        })
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ExcelRenewal', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ExcelRenewal = true
      }
    })
  },
  methods: {
    renew (row) {
      this.$confirm('是否确定为此用户续费?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiaddrenewalorder(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetrenewaltyjnum()
      this.apiGetrenewaltyjlist()
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetrenewaltyjlist()
    },
    clickexcel () {
      this.apiExcelRenewal()
    },
    clickreturn () {
      this.iframesrc = ''
      this.iframestatus = false
    },
    apiGetrenewaltyjlist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        phone: that.keywords.phone,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getrenewaltyjlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetrenewaltyjnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        phone: that.keywords.phone,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getrenewaltyjnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddrenewalorder: function (glassuserid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: glassuserid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addrenewalorder, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            // window.location.href = response.data.Payurl
            // that.iframesrc = response.data.Payurl
            // that.iframestatus = true
            window.open(response.data.Payurl)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelRenewal: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        phone: that.keywords.phone,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelRenewal, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
